import React, { useState, useEffect, useContext, useCallback } from 'react'
import { useMediaQuery, useTheme } from '@material-ui/core'
import clsx from 'clsx'
import useStyles from './styles'
import BoardColumn from './BoardColumn'
import { DragDropContext } from "react-beautiful-dnd"

export const Board = (props) => {
  const { columns, items, cardFields, renderCardItem, skeleton, isFetching, onMoveItem, onCardClick, onItemSelect, isItemSelected } = props
  
  const classes = useStyles()
  const theme = useTheme()

  const getColumnItems = useCallback((col) => {
    if (col.getItems){
      return col.getItems(items)
    }
    return items.filter(item => item.key === col.key)
  }, [items])

  function getColumnSkeleton(col){
    if(col.getSkeleton){
      return col.getSkeleton()
    }
    
    return isFetching ? 3 : 0
  }

  const getSelectedIndexItems = (col) => {
    if(col.getSelectedIndex){
      return col.getSelectedIndex(getColumnItems(col))
    }
    
    return -1
  }

  const onDragTaskStart = (item) => {
  }

  const onDragTaskEnd = (result) => {
    // alert("onDragTaskEnd: " + JSON.stringify(result, null, 2))

    if (!onMoveItem)
      return

    if (!result.destination || (
        result.source.droppableId === result.destination.droppableId &&
        result.source.index === result.destination.index
        ))
      return

    const sourceCol = columns.find(col => col.droppableId === result.source.droppableId)
    const destCol = columns.find(col => col.droppableId === result.destination.droppableId)    

    const item = sourceCol.getItems(items)[result.source.index]        

    onMoveItem(item, sourceCol, result.source.index, destCol, result.destination.index)
  }
  
  return (
    <DragDropContext onDragStart={onDragTaskStart} onDragEnd={onDragTaskEnd}>          
      <div className={clsx(classes.board)}>
        {columns
          .map(col =>
              <BoardColumn 
                {...col}
                skeleton={getColumnSkeleton(col)} 
                onCardClick={onCardClick}
                items={getColumnItems(col)}
                cardFields={cardFields}
                renderCardItem={renderCardItem}
                selectedIndex={getSelectedIndexItems(col)}
              />
            )
          .reduce((p, n) => p ? [...p, <div className={classes.boardColumnDivider}/>, n] : [n]
            , null)
        }
      </div>
    </DragDropContext>
  )
}

export default Board